import React,{useContext} from 'react';

import { ThemeContext } from '../../contexts/ThemeContext';

import { servicesData } from '../../data/servicesData';

import './Services.css'
import SingleService from './SingleService/SingleService';

function Services() {

    const { theme } = useContext(ThemeContext);
    return (
        <>
            {servicesData.length > 0 && (
                <div className="services" id="services" style={{backgroundColor:theme.secondary}}>
                    <div className="services-header">
                        <h1 style={{color: theme.primary}}>Hobbies</h1>
                    </div>
                        <p style={{color:theme.tertiary80}}></p>                        
                    <div className="services-body">
                        <div className="services-bodycontainer">
                            {servicesData.map(services => (
                                <SingleService
                                key={services.id}
                                id={services.id}
                                title={services.title}
                                description={services.description}
                                icon={services.icon}/>
                            ))}
                        </div>
                        <br />
                        <h4 style={{color:theme.tertiary80}}>
                            Fun Fact - I love talking about Time Travel 👨‍🚀
                        </h4>                        
                    </div>
                </div>
            )}
       </>
    )
}

export default Services
